import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=a95403da&scoped=true&"
import script from "./StudentCourse.vue?vue&type=script&lang=ts&"
export * from "./StudentCourse.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCourse.vue?vue&type=style&index=0&id=a95403da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95403da",
  null
  
)

export default component.exports